export enum SupportedLanguagesEnum {
    English = "en-CA",
    French = "fr-CA",
}

export type SupportedLanguage = SupportedLanguagesEnum.English | SupportedLanguagesEnum.French;

export interface ITranslateObject extends Record<SupportedLanguage, string> {}

export class TranslateObject implements ITranslateObject {
    [SupportedLanguagesEnum.English] = "";
    [SupportedLanguagesEnum.French] = "";
}
